import React from 'react';
import { StepProps } from '../../types';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HookScreen({
  nextStep
}: StepProps) {
  return <div className="flex-grow flex flex-col justify-center items-center px-6 relative overflow-hidden" data-id="element-287">
      {/* Subtle background elements */}
      <div className="absolute top-[-10%] right-[-5%] w-[60vw] h-[60vw] rounded-full bg-brand/5 blur-3xl -z-10" data-id="element-288" />
      <div className="absolute bottom-[-10%] left-[-5%] w-[40vw] h-[40vw] rounded-full bg-brand/5 blur-3xl -z-10" data-id="element-289" />

      <div className="max-w-3xl mx-auto text-center z-10" data-id="element-290">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-291">
          <span className="inline-block py-1 px-3 rounded-full bg-gray-100 text-gray-600 text-sm font-semibold tracking-wider uppercase mb-4" data-id="element-292">
            Specialty Gap Explorer
          </span>
          <p className="text-lg text-gray-500 font-medium mb-8" data-id="element-293">
            An internal alignment tool for Bayer teams
          </p>
        </motion.div>

        <motion.h1 className="text-4xl md:text-6xl font-bold leading-tight mb-12 text-dark" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-294">
          Are all specialties aligned in how they manage CKD?
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-295">
          <button onClick={nextStep} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white transition-all duration-200 bg-brand rounded-full hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand" data-id="element-296">
            Begin Explorer
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-297" />
          </button>
        </motion.div>
      </div>
    </div>;
}